<!-- @veltra/icons generated sha256:f290ca6bfc9429b0 gen:8 source:src/svg/normal/plus.svg -->
<script setup lang="ts">
defineOptions({ name: 'Plus' })
</script>
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="2"
    viewBox="0 0 24 24"
  >
    <path d="M5 12h14m-7-7v14" />
  </svg>
</template>
